export const ConvertableItem = ({
  id = '',
  unitName = '',
  floorplanName = '',
  beds = '',
  baths = '',
  price = '',
  squareFeet = '',
}) => ({
  id: String(id),
  floorplanName: String(floorplanName),
  unitName: String(unitName),
  beds: String(beds),
  baths: String(baths),
  price: String(price),
  squareFeet: String(squareFeet),
});

export const ConvertableOption = ({
  baths,
  beds,
  price = 0,
  squareFeet,
  name = '',
  floorplanName = '',
  floorPlanId = '',
  highPrice = 0,
  lowPrice = 0,
  unitId = '',
}) => {
  const displayText = unitId ? `${floorplanName} (Unit: ${name})` : `${name}`;
  let displayBeds = beds || '';
  if (beds === 0) {
    displayBeds = 'Studio';
  }
  const finalPrice = price || lowPrice || highPrice || 0;
  const finalId = unitId || floorPlanId;

  return {
    label: String(displayText),
    value: String(displayText),
    convertableItem: ConvertableItem({
      id: String(finalId),
      unitName: floorplanName ? String(name) : '',
      floorplanName: floorplanName ? String(floorplanName) : String(name),
      beds: String(displayBeds),
      baths: String(baths),
      price: String(finalPrice),
      squareFeet: String(squareFeet),
    }),
  };
};
